import ModelUtils from '../../utils/model';
import { getElementStyles } from './elements/elementStyles';

export const pickByPrefix = (prefix, obj) => Object.entries(obj).reduce((picked, [key, val]) => {
    if (key.startsWith(prefix)) {
        picked.push(val);
    }
    return picked;
}, []);

export const getParentOffset = parents => parents.reduce(
    (offset, parent) => ({
        x: offset.x + parent.x,
        y: offset.y + parent.y,
    }), 
    { x: 0, y: 0 },
);

export const getParents = (element, groupElements, parents = []) => {
    if (element && element.groupElementId) {
        const parent = groupElements.find(grp => grp.id === element.groupElementId);
        if (!parent) {
            throw new Error(`Could not find parent with ID ${element.groupElementId} of ${element.elementType} "${element.developerName}" with ID ${element.id}`);
        }
        parents.push(parent);
        return getParents(parent, groupElements, parents);
    }   

    return parents;
};

const SYSTEM_FLOW_MAPPINGS = {
    input: 'Map Element Page',
    step: 'Map Element Step',
    decision: 'Map Element Decision',
    operator: 'Map Element Operator',
    message: 'Map Element Message',
    database_load: 'Map Element Database Load',
    database_save: 'Map Element Database Save',
    database_delete: 'Map Element Database Delete',
    swimlane: 'Map Element Swimlane',
    // subflow, return and start do not have editing system flows
};

export const getSystemFlowName = elementType => SYSTEM_FLOW_MAPPINGS[elementType];

// We receive inputs as { key: value,... }
// and convert to [{ Key: value },...]
export const mapObjectToSystemFlowInputs = inputs => Object.entries(inputs)
    .map(([key, value]) => {
        // flow input keys are upper-camel-cased eg. 'MyKey'
        const camelCaseKey = `${key[0].toUpperCase()}${key.substring(1)}`;

        const newObject = {};
        newObject[camelCaseKey] = value;

        return newObject;
    });

export const generateIDs = (inputs) => {
    if (inputs.id === '') {
        inputs.id = ModelUtils.guid();
    }
    return inputs;
};

export const snap = value => Math.round(value / 10) * 10;

export const getElementsDimensions = (elementIds, mapElements, groupElements) => {
    let lowestX;
    let highestX;
    let lowestY;
    let highestY;

    elementIds.forEach((elementId) => {
        const element = mapElements.find(el => el.id === elementId) || groupElements.find(el => el.id === elementId);
        if (!element) { return }
        const parentOffset = getParentOffset(getParents(element, groupElements));
        const styles = getElementStyles(element.elementType);

        const leftX = element.x + parentOffset.x;
        const rightX = leftX + ((styles.mapElement && styles.mapElement.width) || element.width);
        const upperY = element.y + parentOffset.y;
        const bottomY = upperY + ((styles.mapElement && styles.mapElement.height) || element.height);

        if (lowestX === undefined || leftX < lowestX) {
            lowestX = leftX;
        }
        if (highestX === undefined || rightX > highestX) {
            highestX = rightX;
        }
        if (lowestY === undefined || upperY < lowestY) {
            lowestY = upperY;
        }
        if (highestY === undefined || bottomY > highestY) {
            highestY = bottomY;
        }
    });

    return { lowestX, highestX, lowestY, highestY };
};
